import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb29d56e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "grid-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsDatepicker = _resolveComponent("AsDatepicker")!
  const _component_AsDropdown = _resolveComponent("AsDropdown")!
  const _component_AsButton = _resolveComponent("AsButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["clinic-history-input", { padding: _ctx.isReadOnly }])
  }, [
    (_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.model && _ctx.model.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, _toDisplayString(_ctx.getFormattedDate(item.date)) + " - " + _toDisplayString(_ctx.getLookUpValue(_ctx.lvTypes.HistoryInput, item.historyInputTypeId)), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.getValueOrDefault('')), 1))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "grid-container"
            }, [
              _createVNode(_component_AsDatepicker, {
                placeholder: _ctx.$t('datePlaceholder'),
                value: item.date,
                enableTimePicker: false,
                label: 'Date',
                onUpdate: (date) => (item.date = date)
              }, null, 8, ["placeholder", "value", "onUpdate"]),
              _createVNode(_component_AsDropdown, {
                clearIcon: true,
                value: item.historyInputTypeId,
                options: _ctx.getLookUpOptions(_ctx.lvTypes.HistoryInput),
                placeholder: _ctx.$t('SelectTypePlaceholder'),
                optionValue: 'id',
                optionLabel: 'value',
                label: 'Type',
                onUpdate: (value) => (item.historyInputTypeId = value)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: "pi pi-trash",
                    onClick: ($event: any) => (_ctx.removeItem(item))
                  }, null, 8, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["value", "options", "placeholder", "onUpdate"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_AsButton, {
                class: "right-aligned-items",
                type: _ctx.bTypes.Primary,
                label: _ctx.$t('AddNew'),
                onClick: _ctx.addNewHistoryItem
              }, null, 8, ["type", "label", "onClick"])
            ])
          ])
        ]))
  ], 2))
}